module.exports = __webpack_public_path__ + "static/media/arrow-down.dc084081.png";